import { SearchBox } from './SearchBox';

// TODO: in v9, move styled() from SearchBox.jsx to here
export var StyledSearchBox = SearchBox;